import React from 'react';
import classnames from 'classnames';
import { Icon } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import FilterStickyHeaderIndicator from '../FilterStickyHeaderIndicator';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { isEmpty } from '@intelligence/v3/utils/common';

interface IFilterStickyHeaderSummaryItem {
  key: string;
  content: React.ReactNode;
}

interface IFilterStickyHeaderProps extends IBaseProps {
  title?: string;
  /** 是否在摘要区显示"我的筛选器"内置标识；当 beforeSummaryContent 存在时自动隐藏避免重复 */
  showSavedFilterIndicator?: boolean;
  /** 插入到摘要区前面的自定义扩展内容；存在时会抑制 showSavedFilterIndicator 的内置标识渲染 */
  beforeSummaryContent?: React.ReactNode;
  summaryItems?: IFilterStickyHeaderSummaryItem[] | null;
  onClick: (e: React.MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void;
}

const FilterStickyHeader: React.FC<IFilterStickyHeaderProps> = (props) => {
  const {
    style,
    className,
    title,
    showSavedFilterIndicator = false,
    beforeSummaryContent,
    summaryItems,
    onClick,
  } = props;

  const { formatMessage } = useIntlExtend();

  return (
    <div
      style={style}
      className={classnames('dbi-filter-sticky-header', className, { 'dbi-filter-sticky-header--no-title': !title })}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
    >
      {!!title && <div className="dbi-filter-sticky-header__title">{title}</div>}
      <div className="dbi-filter-sticky-header__body">
        {!!beforeSummaryContent && <div className="dbi-filter-sticky-header__filters">{beforeSummaryContent}</div>}
        <div className="dbi-filter-sticky-header__summary">
          {showSavedFilterIndicator && !beforeSummaryContent && (
            <FilterStickyHeaderIndicator
              text="dbi_filterSave_my_filter"
              icon={<Icon className="dbi-filter-sticky-header__saved-filter-icon" type="filter" />}
            />
          )}
          {summaryItems?.map((item) => {
            const itemContent = item?.content;
            if (isEmpty(itemContent)) {
              return null;
            }

            return (
              <div key={item?.key} className="dbi-filter-sticky-header__summary-item">
                {itemContent}
              </div>
            );
          })}
        </div>
        <div className="dbi-filter-sticky-header__show">
          <span>{formatMessage({ id: 'dbi_filter_show' })}</span>
          <SvgIcon className="dbi-filter-sticky-header__show-arrow" type="point-down" />
        </div>
      </div>
    </div>
  );
};

export default FilterStickyHeader;
